<template>
  <div class="card">
    <div class="card-header">
      <span>{{ header }}</span>
      <button
        v-if="showEditButton && !editModeValue"
        class="btn btn-default float-right"
        type="button"
        @click="editModeValue = !editModeValue"
      >
        Edit {{ editButtonText }} <i class="icon--pencil" />
      </button>
    </div>
    <div class="card-body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
    name: 'Card',
    props: ['header', 'showEditButton', 'editMode', 'editButtonText'],
    computed: {
        editModeValue: {
            get: function () {
                return this.editMode
            },
            set: function (newValue) {
                this.$emit('update:editMode', newValue)
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
